function shiftRow(row) {
    return row
        .split(/\s+/)
        .map((token) => (/^[a-z]$/.test(token) ? token.toUpperCase() : token))
        .join(' ');
}

function withShiftRows(normalRows) {
    return normalRows.map(shiftRow);
}

function buildNumericLayout(trailingTokens) {
    return { normal: ['1 2 3', '4 5 6', '7 8 9', `${trailingTokens} 0 {b}`] };
}

export const NUMERIC_DOT_LAYOUT = buildNumericLayout('.');
export const NUMERIC_PHONE_LAYOUT = buildNumericLayout('-');
export const NUMERIC_SPACE_LAYOUT = buildNumericLayout('{sp:1}');
export const SIGNED_DECIMAL_LAYOUT = buildNumericLayout('. -');

const ZIP_LETTERS_ROWS = [
    '1 2 3 4 5 6 7 8 9 0 - {b}',
    'Q W E R T Y U I O P',
    'A S D F G H J K L',
    'Z X C V B N M',
    '{space} {normal}'
];

export const ZIP_LAYOUT = {
    ...buildNumericLayout('{alt}'),
    alt: ZIP_LETTERS_ROWS
};

const HEBREW_LETTER_ROWS = [
    '1 2 3 4 5 6 7 8 9 0 - {b}',
    "/ ' ק ר א ט ו ן ם פ ] [",
    'ש ד ג כ ע י ח ל ך ף ,',
    'ז ס ב ה נ מ צ ת ץ .',
];

export const HEBREW_KEYBOARD_LAYOUT = {
    normal: [...HEBREW_LETTER_ROWS, '{space}']
};

const HEBREW_PHYSICAL_ROWS = [
    ['KeyQ', 'KeyW', 'KeyE', 'KeyR', 'KeyT', 'KeyY', 'KeyU', 'KeyI', 'KeyO', 'KeyP', 'BracketLeft', 'BracketRight'],
    ['KeyA', 'KeyS', 'KeyD', 'KeyF', 'KeyG', 'KeyH', 'KeyJ', 'KeyK', 'KeyL', 'Semicolon', 'Quote'],
    ['KeyZ', 'KeyX', 'KeyC', 'KeyV', 'KeyB', 'KeyN', 'KeyM', 'Comma', 'Period', 'Slash']
];

function hebrewPhysicalKeyMap() {
    const letterRows = HEBREW_LETTER_ROWS.slice(1).map((row) => row.split(/\s+/));
    const map = {};
    letterRows.forEach((tokens, index) => {
        const codes = HEBREW_PHYSICAL_ROWS[index];
        if (!codes || tokens.length !== codes.length) {
            throw new Error('hebrew keyboard row does not match physical keys');
        }
        tokens.forEach((token, column) => {
            map[codes[column]] = token;
        });
    });
    return map;
}

export const HEBREW_PHYSICAL_KEYS = hebrewPhysicalKeyMap();

const HEBREW_ALT_LAYOUT = { alt: [...HEBREW_LETTER_ROWS, '{space} {normal}'] };

const EMAIL_NORMAL_ROWS = [
    '1 2 3 4 5 6 7 8 9 0 - {b}',
    'q w e r t y u i o p',
    'a s d f g h j k l',
    '{shift} z x c v b n m . _ @ {shift}',
    '@gmail.com @hotmail.com @yahoo.com'
];

export const EMAIL_LAYOUT = {
    normal: EMAIL_NORMAL_ROWS,
    shift: withShiftRows(EMAIL_NORMAL_ROWS)
};

const TEXT_SYMBOLS_LAYOUT = ['! ? & ( ) \' "', ': ; - _ / *', '{space} {abc}'];

const LETTER_CONTENT_ROWS = [
    '1 2 3 4 5 6 7 8 9 0 - {b}',
    'q w e r t y u i o p',
    'a s d f g h j k l',
    '{shift} z x c v b n m , .'
];

const TEXT_NORMAL_ROWS = [...LETTER_CONTENT_ROWS, '{space} {sym} {alt}'];

export const TEXT_LAYOUT = {
    normal: TEXT_NORMAL_ROWS,
    shift: withShiftRows(TEXT_NORMAL_ROWS),
    symbols: TEXT_SYMBOLS_LAYOUT,
    ...HEBREW_ALT_LAYOUT
};

const MULTILINE_TEXT_NORMAL_ROWS = [...LETTER_CONTENT_ROWS, '{space} {enter} {sym} {alt}'];

export const MULTILINE_TEXT_LAYOUT = {
    ...TEXT_LAYOUT,
    normal: MULTILINE_TEXT_NORMAL_ROWS,
    shift: withShiftRows(MULTILINE_TEXT_NORMAL_ROWS)
};

const SELECT2_SEARCH_NORMAL_ROWS = [...LETTER_CONTENT_ROWS, '{space} {alt}'];

export const SELECT2_SEARCH_LAYOUT = {
    normal: SELECT2_SEARCH_NORMAL_ROWS,
    shift: withShiftRows(SELECT2_SEARCH_NORMAL_ROWS),
    ...HEBREW_ALT_LAYOUT
};
